import { cn } from "@/lib/utils";
import { useState } from "react";

export default function CommentTerm({
  children = null,
  chessTerm,
  onChessTermClick,
  onChessTermOver,
  onChessTermOut,
}) {
  const [clicked, setClicked] = useState(false);

  return (
    <span
      onMouseOver={() => onChessTermOver(chessTerm)}
      onMouseOut={() => onChessTermOut(chessTerm)}
      onClick={() => {
        onChessTermClick();
        setClicked(!clicked);
      }}
      className={cn(
        "px-1 py-0 whitespace-nowrap rounded border-b border-gray-300 cursor-pointer select-none",
        clicked ? "text-white bg-gray-600" : "bg-gray-200 hover:bg-gray-300"
      )}
    >
      {children}
    </span>
  );
}
